/**
 * @file       secure module
 * @version    2.0.0
 * @author     Mehran Majidi
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from 
        '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { ShareModule } from './share/share.module';

import { SecureRoutingModule } from './secureRouting.module';
import { SecureLayoutComponent } from './core/layout/secureLayout.component';
import { SecureHeaderComponent } from './core/layout/secureHeader.component';

import { BasicAuthInterceptor } from './helper/auth.interceptor';
import { ErrorInterceptor } from './helper/error.interceptor';
import { LoadingInterceptor } from './helper/loading.interceptor';
import { AuthGuard } from './helper/auth.guard';
import { IdleTimeoutComponent } from './core/timeout/idleTimeout.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
    imports: 
    [  
        ModalModule,
        SecureRoutingModule,
        NgIdleKeepaliveModule.forRoot(),
        MatDialogModule,
        SecureHeaderComponent,
        SecureLayoutComponent,        
        IdleTimeoutComponent      
    ],
    exports: [],
    declarations: 
    [
    ],
    providers: 
    [
        BsModalService,
        { provide: HTTP_INTERCEPTORS, 
          useClass: BasicAuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, 
          useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS,
          useClass: LoadingInterceptor, multi: true },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },

        AuthGuard
    ],
})
export class SecureModule {}
